import { Quote } from "lucide-react";
import { useContent } from "../../context/ContentContext";
import { Reveal } from "./Reveal";
import { SectionBg } from "./SectionBg";

export const Testimonials = () => {
  const { content } = useContent();
  return (
    <section className="relative overflow-hidden bg-[#050505] py-24 md:py-40 border-t border-white/10" data-testid="testimonials-section">
      <SectionBg id="testimonials" />
      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12">
        <Reveal className="mb-16 md:mb-24 max-w-2xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-electric" />
            <span className="text-[11px] tracking-[0.35em] uppercase text-electric">Témoignages</span>
          </div>
          <h2 className="font-serif text-5xl md:text-7xl text-white tracking-tight leading-[0.95]">
            Ils nous ont fait <span className="italic text-electric">confiance.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {content.testimonials.map((t, i) => (
            <Reveal key={i} delay={i * 0.12}
              className="group relative p-8 md:p-10 rounded-lg border border-white/10 bg-white/[0.02] backdrop-blur-sm hover:border-electric/40 transition-colors duration-500 h-full flex flex-col">
              <div className="absolute -top-px left-8 h-px w-0 bg-electric group-hover:w-16 transition-all duration-700" />
              <Quote size={40} className="text-electric/30 mb-6" />
              <p className="font-serif text-xl md:text-2xl text-white/90 leading-snug flex-1">"{t.quote}"</p>
              <div className="mt-8 pt-6 border-t border-white/10">
                <div className="text-white text-sm">{t.name}</div>
                <div className="text-secondary2 text-[11px] tracking-[0.2em] uppercase mt-1">{t.role}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
